import { Outlet } from "react-router-dom";
import { App } from "antd";

import { HelmetProvider } from "react-helmet-async";

import { MessageContextProvider } from "@contexts/Message";
import { NotificationContextProvider } from "@contexts/Notification";
import { AuthContextProvider } from "@contexts/Auth";
import { CorbanContextProvider } from "@contexts/Corban";
import { PermissionsContextProvider } from "@contexts/Permissions";

import AppConfig from "../AppConfig";
import { ClientSettingsProvider } from "@contexts/ClientSettings";
import { CacheRefreshProvider } from "@contexts/CacheRefresh";
import { StyleProvider } from "@styles/StyleProvider";
import { MonitoringProvider } from "@contexts/Monitoring";
import { NotificationsProvider } from "@contexts/Notifications/provider";

export const ProvidersAndConfigs = () => {
  return (
    <HelmetProvider>
      <ClientSettingsProvider>
        <CacheRefreshProvider>
          <MonitoringProvider>
            <StyleProvider>
              <App component={false}>
                <MessageContextProvider>
                  <NotificationContextProvider>
                    <AuthContextProvider>
                      <CorbanContextProvider>
                        <PermissionsContextProvider>
                          <AppConfig>
                            <NotificationsProvider>
                              <Outlet />
                            </NotificationsProvider>
                          </AppConfig>
                        </PermissionsContextProvider>
                      </CorbanContextProvider>
                    </AuthContextProvider>
                  </NotificationContextProvider>
                </MessageContextProvider>
              </App>
            </StyleProvider>
          </MonitoringProvider>
        </CacheRefreshProvider>
      </ClientSettingsProvider>
    </HelmetProvider>
  );
};
